import { NavigationItem } from './navigation.interface';

export const uiItems: NavigationItem[] = [
  {
    id: 'typography',
    label: 'Typographie',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/typography',
  },
];

export const adminHomeItems: NavigationItem[] = [
  {
    id: 'admin_home',
    label: 'Home',
    type: 'basic',
    icon: 'house',
    link: '/home',
  },
  {
    id: 'collection',
    label: 'Collections',
    type: 'collapsable',
    icon: 'group',
    children: [
      {
        id: 'collection.core',
        label: 'CORE',
        type: 'collapsable',
        icon: 'folder',
        children: [
          {
            id: 'collection.users',
            label: 'Utilisateurs',
            type: 'basic',
            link: '/users',
            icon: 'user',
          },
          {
            id: 'collection.user-registrations',
            label: 'Inscriptions',
            type: 'basic',
            link: '/user-registrations',
            icon: 'file-user',
          },
          {
            id: 'collection.beta-registrations',
            label: 'Inscriptions Bêta',
            type: 'basic',
            link: '/beta-registrations',
            icon: 'flask-conical',
          },
          {
            id: 'collection.token-vaults',
            label: 'Token Vaults',
            type: 'basic',
            link: '/token-vaults',
            icon: 'key',
          },
          {
            id: 'collection.emails',
            label: 'Emails',
            type: 'basic',
            icon: 'mail',
            link: '/emails',
          },
          {
            id: 'collection.sms',
            label: 'SMS',
            type: 'basic',
            icon: 'message-square-text',
            link: '/sms',
          },
          {
            id: 'collection.notifications',
            label: 'Notifications',
            type: 'basic',
            icon: 'bell',
            link: '/notifications',
          },

          {
            id: 'collection.tickets',
            label: 'Tickets',
            type: 'basic',
            icon: 'ticket',
            link: '/tickets',
          },
          {
            id: 'collection.files',
            label: 'Fichiers',
            type: 'basic',
            icon: 'files',
            link: '/files',
          },
          {
            id: 'collection.subscriptions',
            label: 'Abonnements',
            type: 'basic',
            icon: 'repeat',
            link: '/subscriptions',
          },
          {
            id: 'collection.transactions',
            label: 'Transactions',
            type: 'basic',
            icon: 'receipt-text',
            link: '/transactions',
          },
          {
            id: 'collection.plans',
            label: 'Plans',
            type: 'basic',
            icon: 'credit-card',
            link: '/plans',
          },
        ],
      },
      {
        id: 'collection.etxe',
        label: 'ETXE',
        type: 'collapsable',
        icon: 'folder',
        children: [
          {
            id: 'collection.properties',
            label: 'Biens',
            type: 'basic',
            icon: 'house',
            link: '/properties',
          },
          {
            id: 'collection.agents',
            label: 'Agents',
            type: 'basic',
            icon: 'user',
            link: '/agents',
          },
          {
            id: 'collection.agent-cards',
            label: 'Cartes pro',
            type: 'basic',
            icon: 'id-card',
            link: '/agent-cards',
          },
        ],
      },
      {
        id: 'collection.dev',
        label: 'DEV',
        type: 'collapsable',
        icon: 'folder',
        expanded: false,
        children: [
          {
            id: 'collection.stripe-subscription-events',
            label: 'Événements Stripe',
            type: 'basic',
            icon: 'refresh-cw',
            link: '/stripe-subscription-events',
          },
          {
            id: 'collection.stripe-verification-sessions',
            label: 'Vérifications Stripe',
            type: 'basic',
            icon: 'shield-check',
            link: '/stripe-verification-sessions',
          },
          {
            id: 'collection.job-configs',
            label: 'Configurations des Jobs',
            type: 'basic',
            icon: 'cog',
            link: '/job-configs',
          },
        ],
      },
    ],
  },
];

export const publicOwnerItems: NavigationItem[] = [
  {
    id: 'public_case_study',
    label: 'Étude de cas',
    type: 'basic',
    icon: 'sparkles',
    link: '/etude-de-cas',
  },
  // Masqué temporairement : aucun agent pour l'instant
  // {
  //   id: 'public_agents',
  //   label: 'Agents certifiés',
  //   type: 'basic',
  //   icon: 'user',
  //   link: '/agents',
  // },
];

export const publicProItems: NavigationItem[] = [
  {
    id: 'public_pro_case_study',
    label: 'Étude de cas',
    type: 'basic',
    icon: 'sparkles',
    link: '/etude-de-cas',
    queryParams: { tab: 'agent-preview' },
  },
  // Masqué temporairement : aucun agent pour l'instant
  // {
  //   id: 'public_pro_directory',
  //   label: 'Annuaire public',
  //   type: 'basic',
  //   icon: 'user',
  //   link: '/agents',
  // },
];

export const publicItems: NavigationItem[] = publicOwnerItems;

export const agentItems: NavigationItem[] = [
  {
    id: 'agent_become',
    label: 'Devenir agent',
    type: 'basic',
    icon: 'house',
    link: '/become-agent',
  },
  {
    id: 'agent_subscriptions',
    label: 'Abonnements',
    type: 'basic',
    icon: 'house',
    link: '/subscriptions',
  },
];

export const activeAgentItems: NavigationItem[] = [
  {
    id: 'agent_agenda',
    label: 'Agenda',
    type: 'basic',
    icon: 'calendar',
    link: '/agenda',
  },
  {
    id: 'agent_follow_up',
    label: 'Suivi',
    type: 'basic',
    icon: 'clipboard-list',
    link: '/follow-up',
  },
  {
    id: 'agent_subscriptions',
    label: 'Abonnements',
    type: 'basic',
    icon: 'credit-card',
    link: '/subscriptions',
  },
];

export const activeAgentSubscribedItems: NavigationItem[] = [
  {
    id: 'agent_agenda',
    label: 'Agenda',
    type: 'basic',
    icon: 'calendar',
    link: '/agenda',
  },
  {
    id: 'agent_contacts',
    label: 'Contacts',
    type: 'basic',
    icon: 'contact',
    link: '/contacts',
  },
  {
    id: 'agent_follow_up',
    label: 'Suivi',
    type: 'basic',
    icon: 'clipboard-list',
    link: '/follow-up',
  },
  {
    id: 'agent_advertising',
    label: 'Publicité',
    type: 'basic',
    icon: 'megaphone',
    link: '/advertising',
  },
];

export const getOwnerNavigationItems = (hasOwnerProfile: boolean): NavigationItem[] => {
  const items: NavigationItem[] = [
    {
      id: 'owner_properties',
      label: 'Biens',
      type: 'basic',
      icon: 'house',
      link: '/properties',
    },
  ];

  if (hasOwnerProfile) {
    items.push({
      id: 'owner_agenda',
      label: 'Agenda',
      type: 'basic',
      icon: 'calendar',
      link: '/agenda',
    });
  }

  return items;
};

export const ownerItems: NavigationItem[] = getOwnerNavigationItems(true);
